import React from 'react'
import { useTranslation } from 'react-i18next'
export function Instruction1P() {
  return (
    <React.Fragment>
      <article>
        <h1>Instrukcja:</h1>
        <p>
          Przedstawiamy Państwu kwestionariusz dotyczący rozwoju poznawczego
          Państwa dziecka (podopiecznego).
        </p>
        <p>
          Zawiera on liczne stwierdzenia opisujące możliwe zachowania i
          umiejętności pojawiające się w rozwoju od 3 roku życia do dorosłości.
          Oznacza to, że niektóre z nich nie będą adekwatne do Państwa dziecka
          (ucznia). Mogą dotyczyć okresu rozwojowego, który jeszcze nie
          nastąpił. Dlatego naturalne będzie, że dla niektórych stwierdzeń będą
          musieli Państwo wybrać odpowiedź „Jeszcze nie”.
        </p>
        <p>
          <u>Mają Państwo do wyboru 5 kategorii odpowiedzi:</u>
        </p>
        <p>
          <strong>TAK</strong> – zaznaczamy, gdy dziecko opanowało daną
          umiejętność i obecnie wykonuje ją samodzielnie lub wykonywało ją w
          przeszłości (na przykład – gaworzenie: dziecko gaworzyło gdy było
          młodsze, a aktualnie tego nie robi, komunikuje się w inny sposób).
          Oznacza to, że w przypadku zachowań, które obecnie nie występują, bo
          dziecko z nich „wyrosło”, ale pojawiały się we wcześniejszym okresie,
          wybieramy odpowiedź TAK.
        </p>
        <p>
          <strong>TAK z pomocą werbalną lub fizyczną</strong> – zaznaczamy, gdy
          do wykonania zadania dziecko potrzebuje albo konkretnej instrukcji
          słownej – prowadzenia krok po kroku, albo pomocy bezpośredniej (na
          przykład w przytrzymaniu klocka).
        </p>
        <p>
          <strong>CZĘŚCIOWO</strong> – zaznaczamy, gdy dziecko wykonuje daną
          czynność samo lub z pomocą, ale nie w pełni, nie doprowadza jej do
          końca lub wykonuje ją tylko czasami (np. czasami rozróżnia położenie
          <i> góra – dół</i>, a czasami mu się to myli).
        </p>
        <p>
          <strong>JESZCZE NIE</strong> – zaznaczamy, gdy dziecko nie opanowało
          jeszcze danej umiejętności, co nie oznacza, że nie pojawi się ona w
          kolejnych etapach rozwoju.
        </p>
        <p>
          <strong>NIE DOTYCZY</strong> – odpowiedź, którą mogą wskazywać Państwo
          tylko w takich sytuacjach, gdy naprawdę nie da się odnieść
          stwierdzenia do Państwa dziecka (ucznia).
        </p>
        <p>
          Przypominamy, że w przypadku, gdy pytanie nie dotyczy dziecka w chwili
          badania, bo opisane zachowanie pojawiało się wcześniej w jego rozwoju,
          na przykład gdy było małe, wybieramy odpowiedź TAK a nie NIE DOTYCZY.
        </p>
        <p>
          Kategoria NIE DOTYCZY powinna być wybierana, gdy nie mogą Państwo
          udzielić innej odpowiedzi ze względu na niepełnosprawność dziecka:
        </p>
        <ul>
          <li>
            Ruchową – dziecko nie chwyta, nie chodzi, czyli pytanie np. o
            przekładanie czy chwytanie go nie dotyczy itp.;
          </li>
          <li>
            W zakresie rozwoju mowy – dziecko nie mówi, a zatem pytania
            dotyczące mowy – wypowiadania głosek, zdań, nazywania go nie
            dotyczą;
          </li>
          <li>
            Wzrokową – dziecko nie widzi, więc nie może „śledzić wzrokiem” czy
            dostrzegać różnic na obrazkach, a zatem tego typu pytania go nie
            dotyczą.
          </li>
        </ul>
        <p>
          Prosimy o jak najrzadsze wybieranie tej odpowiedzi. Na zakończenie
          kwestionariusza prosimy o krótkie uzasadnienie wskazanych odpowiedzi
          NIE DOTYCZY.
        </p>
        <p>
          <strong>
            Prosimy o szczere odpowiedzi, dzięki czemu uzyskamy bardziej
            obiektywny obraz funkcjonowania Państwa dziecka.
          </strong>
        </p>
        <p>
          Jeżeli będzie Pan/i chciał/a zmienić swoją odpowiedź, proszę wrócić do
          tego pytania i zmienić odpowiedź. W przypadku, gdy trudno wybrać
          właściwą odpowiedź, proszę wybrać tę, która jest Pani/Pana zdaniem
          najbliższa prawdy. Ważne jest aby Pan/i nie opuścił/a żadnego pytania.
        </p>
        <p>
          Gdy dziecko nie posługuje się mową, oceniamy reakcje dziecka
          przejawiające się w różny sposób – np. zainteresowanie, czy wyraz
          rozumienia albo emocji – może przejawiać się na różne sposoby – np.
          przez przyśpieszony oddech, zaczerwienienie twarzy, szybsze bicie
          serca, nagłe spocenie się, płacz lub autoagresję.
        </p>
      </article>
    </React.Fragment>
  )
}
export function Instruction1T() {
  return (
    <React.Fragment>
      <article>
        <h1>Instrukcja:</h1>
        <p>
          Przedstawiamy Państwu kwestionariusz dotyczący rozwoju poznawczego
          Państwa dziecka (ucznia).
        </p>
        <p>
          Zawiera on liczne stwierdzenia opisujące możliwe zachowania i
          umiejętności pojawiające się w rozwoju od 3 roku życia do dorosłości.
          Oznacza to, że niektóre z nich nie będą adekwatne do Państwa dziecka
          (ucznia). Mogą dotyczyć okresu rozwojowego, który jeszcze nie
          nastąpił. Dlatego naturalne będzie, że dla niektórych stwierdzeń będą
          musieli Państwo wybrać odpowiedź „Jeszcze nie”.
        </p>
        <p>
          <u>Mają Państwo do wyboru 5 kategorii odpowiedzi:</u>
        </p>
        <p>
          <strong>TAK</strong> – zaznaczamy, gdy dziecko opanowało daną
          umiejętność i obecnie wykonuje ją samodzielnie lub wykonywało ją w
          przeszłości (na przykład – gaworzenie: dziecko gaworzyło gdy było
          młodsze, a aktualnie tego nie robi, komunikuje się w inny sposób).
          Oznacza to, że w przypadku zachowań, które obecnie nie występują, bo
          dziecko z nich „wyrosło”, ale pojawiały się we wcześniejszym okresie,
          wybieramy odpowiedź TAK.
        </p>
        <p>
          <strong>TAK z pomocą werbalną lub fizyczną</strong> – zaznaczamy, gdy
          do wykonania zadania dziecko potrzebuje albo konkretnej instrukcji
          słownej – prowadzenia krok po kroku, albo pomocy bezpośredniej (na
          przykład w przytrzymaniu klocka).
        </p>
        <p>
          <strong>CZĘŚCIOWO</strong> – zaznaczamy, gdy dziecko wykonuje daną
          czynność samo lub z pomocą, ale nie w pełni, nie doprowadza jej do
          końca lub wykonuje ją tylko czasami (np. czasami rozróżnia położenie
          <i> góra – dół</i>, a czasami mu się to myli).
        </p>
        <p>
          <strong>JESZCZE NIE</strong> – zaznaczamy, gdy dziecko nie opanowało
          jeszcze danej umiejętności, co nie oznacza, że nie pojawi się ona w
          kolejnych etapach rozwoju.
        </p>
        <p>
          <strong>NIE DOTYCZY</strong> – odpowiedź, którą mogą wskazywać Państwo
          tylko w takich sytuacjach, gdy naprawdę nie da się odnieść
          stwierdzenia do Państwa dziecka (ucznia).
        </p>
        <p>
          Przypominamy, że w przypadku, gdy pytanie nie dotyczy dziecka w chwili
          badania, bo opisane zachowanie pojawiało się wcześniej w jego rozwoju,
          na przykład gdy było małe, wybieramy odpowiedź TAK a nie NIE DOTYCZY.
        </p>
        <p>
          Kategoria NIE DOTYCZY powinna być wybierana, gdy nie mogą Państwo
          udzielić innej odpowiedzi ze względu na niepełnosprawność dziecka:
        </p>
        <ul>
          <li>
            Ruchową – dziecko nie chwyta, nie chodzi, czyli pytanie np. o
            przekładanie czy chwytanie go nie dotyczy itp.;
          </li>
          <li>
            W zakresie rozwoju mowy – dziecko nie mówi, a zatem pytania
            dotyczące mowy – wypowiadania głosek, zdań, nazywania go nie
            dotyczą;
          </li>
          <li>
            Wzrokową – dziecko nie widzi, więc nie może „śledzić wzrokiem” czy
            dostrzegać różnic na obrazkach, a zatem tego typu pytania go nie
            dotyczą.
          </li>
        </ul>
        <p>
          Prosimy o jak najrzadsze wybieranie tej odpowiedzi. Na zakończenie
          kwestionariusza prosimy o krótkie uzasadnienie wskazanych odpowiedzi
          NIE DOTYCZY.
        </p>
        <p>
          <strong>
            Prosimy o szczere odpowiedzi, dzięki czemu uzyskamy bardziej
            obiektywny obraz funkcjonowania Państwa dziecka.
          </strong>
        </p>
        <p>
          Jeżeli będzie Pan/i chciał/a zmienić swoją odpowiedź, proszę wrócić do
          tego pytania i zmienić odpowiedź. W przypadku, gdy trudno wybrać
          właściwą odpowiedź, proszę wybrać tę, która jest Pani/Pana zdaniem
          najbliższa prawdy. Ważne jest aby Pan/i nie opuścił/a żadnego pytania.
        </p>
        <p>
          Gdy dziecko nie posługuje się mową, oceniamy reakcje dziecka
          przejawiające się w różny sposób – np. zainteresowanie, czy wyraz
          rozumienia albo emocji – może przejawiać się na różne sposoby – np.
          przez przyśpieszony oddech, zaczerwienienie twarzy, szybsze bicie
          serca, nagłe spocenie się, płacz lub autoagresję.
        </p>
      </article>
    </React.Fragment>
  )
}
export function Instruction2T() {
  return (
    <React.Fragment>
      <article>
        <h1>Instrukcja:</h1>
        <p>
          Poniżej znajduje się lista zachowań Pani/Pana ucznia. Proszę
          przeczytać kolejne pytania zaczynające się od:{' '}
          <strong>„Czy dziecko…?”</strong> i w każdym przypadku wybrać jedną
          odpowiedź. Proszę przeczytać uważnie każde pytanie i zaznaczyć, jak
          często dane zachowanie pojawiało się u dziecka
          <strong> w ciągu ostatniego miesiąca.</strong>
        </p>
      </article>
    </React.Fragment>
  )
}
export function Instruction2P() {
  const { i18n } = useTranslation()
  const language = i18n.language ?? 'pl'
  return (
    <React.Fragment>
      {language === 'pl' && (
        <article>
          <h1>Instrukcja:</h1>
          <p>
            Poniżej znajduje się lista zachowań dziecka. Proszę przeczytać
            kolejne pytania zaczynające się od:{' '}
            <strong>„Czy Pani/Pana dziecko…?”</strong> i w każdym przypadku
            wybrać jedną odpowiedź. Proszę przeczytać uważnie każde pytanie i
            zaznaczyć, jak często dane zachowanie pojawiało się u dziecka
            <strong> w ciągu ostatniego miesiąca.</strong>
          </p>
        </article>
      )}
      {language === 'en' && (
        <article>
          <h1>Instructions:</h1>
          <p>
            Here you will find a list of the types of things that your child may
            be able to do. Please read the following questions which begin with{' '}
            <strong>‘Has your child …?‘</strong> and circle one answer to each
            question. Please read each question carefully and indicate how often
            you have observed your child doing this{' '}
            <strong> over the last month.</strong>
          </p>
        </article>
      )}
      {language === 'vi' && (
        <article>
          <h1>Hướng dẫn:</h1>
          <p>
            Dưới đây là bảng phân dạng hành xử của trẻ. Xin hãy đọc từng câu hỏi
            bắt đầu bằng cụm từ: <strong>„Con của anh/chị…?”</strong> và sau mỗi
            câu hỏi hãy khoanh tròn câu trả lời. Xin hãy đọc kĩ từng câu hỏi và
            đánh dấu con số thể hiện các phong thái hành xử của con mình{' '}
            <strong> trong một tháng trở lại đây.</strong>
          </p>
        </article>
      )}
      {language === 'ua' && (
        <article>
          <h1>Інструкція:</h1>
          <p>
            Нижче наведено список поведінки дитини. Прочитайте питання нижче,
            які починаються з фрази: <strong>«Чи Ваша дитина…?»</strong>, і біля
            кожного обведіть кружечком одну відповідь. Уважно прочитайте кожне
            питання і вкажіть, як часто дана поведінка проявлялась у дитини{' '}
            <strong> протягом останнього місяця.</strong>
          </p>
        </article>
      )}
    </React.Fragment>
  )
}
